<template>
  <v-layout row pa-3>
    <v-fab-transition>
      <v-btn color="pink" dark fixed bottom right fab @click="createItem">
        <v-icon>add</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-flex xs12>
      <v-alert :value="noData" dismissible color="error" icon="warning" outlined
        >We can't find a partner. Please use partner or partner code.</v-alert
      >
      <v-card>
        <v-toolbar text>
          <v-icon>store_mall_directory</v-icon>
          <v-toolbar-title
            >Partners ({{ items.length || 0 }} total)</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchQuery"
            v-on:keyup.enter="search(searchQuery)"
          ></v-text-field>
          <v-btn icon @click.stop="search(searchQuery)">
            <v-icon>search</v-icon>
          </v-btn>
        </v-toolbar>
        <v-data-table
          :headers="headers"
          :items="items"
          :must-sort="true"
          hide-default-footer
          class="mt-1"
        >
          <template v-slot:item="props">
            <tr>
              <td>
                <a @click.stop="updateItem(props.item)">{{
                  props.item.name
                }}</a>
              </td>
              <td>{{ props.item.code }}</td>
              <td>{{ props.item.type }}</td>
              <td>{{ props.item.created | moment("YYYY-DD-MM") }}</td>
              <td>
                <span class="grey--text" v-if="props.item.contact_name"
                  >Contact name :</span
                >
                {{ props.item.contact_name }}
                <br v-if="props.item.contact_name" />
                <span
                  class="grey--text"
                  v-if="props.item.is_online && props.item.link"
                  >Link :</span
                >
                {{ props.item.link }}
                <br v-if="props.item.is_online" />
                <span
                  class="grey--text"
                  v-if="props.item.is_online && props.item.is_username"
                  >Username :</span
                >
                {{ props.item.username }}
                <br v-if="props.item.is_online && props.item.is_username" />
                <span
                  class="grey--text"
                  v-if="props.item.is_online && props.item.is_userpass"
                  >Password :</span
                >
                {{ props.item.userpass }}
                <br v-if="props.item.is_online && props.item.is_userpass" />
                <span class="grey--text" v-if="props.item.email">Email :</span>
                {{ props.item.email }}
                <br v-if="props.item.email" />
                <span class="grey--text" v-if="props.item.phone_number"
                  >Phone number :</span
                >
                {{ props.item.phone_number }}
              </td>
              <td>
                <span
                  v-if="props.item.is_active"
                  class="green--text font-weight-medium"
                  >Active</span
                >
                <span v-else class="red--text font-weight-medium"
                  >Inactive</span
                >
              </td>
              <td>
                <v-btn icon @click.stop="updateItem(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn icon @click.stop="removeItem(props.item.id)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:no-data>No data</template>
        </v-data-table>
        <v-footer class="pt-5"></v-footer>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import fb from "@/firebase";
import { mapMutations } from "vuex";

const partners = fb.db.collection("partner_profiles").orderBy("name");

export default {
  components: {},
  data: () => ({
    items: [],
    newItemName: "",
    currentItem: {},
    searchQuery: "",
    noData: false,
    headers: [
      { text: "Name", value: "name" },
      { text: "Code", value: "code", sortable: false },
      { text: "Type", value: "type", sortable: false },
      { text: "Created", value: "created" },
      { text: "Infos", value: "infos", sortable: false },
      { text: "Status", value: "status", sortable: false },
      { text: "Actions", value: "name", sortable: false, align: "center" }
    ],
    total: 0
  }),
  firestore: {
    items: partners
  },
  methods: {
    ...mapMutations(["setAppAlert"]),
    createItem: function() {
      this.modal.payload = {};
    },
    removeItem: function(id) {
      if (id) {
        if (confirm("Are you sure ?")) {
          partners.doc(id).delete();
          this.setAppAlert({
            visible: true,
            text: "The partner has been removed",
            color: "success"
          });
        }
      }
    },
    updateItem: function(item) {
      this.currentItem = Object.assign({}, item);
      this.currentItem.id = item.id;
    },
    search: function(query) {
      this.noData = false;
      if (query && query.length >= 5) {
        fb.db
          .collection("partner_profiles")
          .where("code", "==", query)
          .get()
          .then(snapshot => {
            if (!snapshot.empty) {
              snapshot.forEach(doc => {
                this.itemFound = doc.data();
                this.itemFound.id = doc.id;
              });
              this.items = [this.itemFound];
            } else {
              fb.db
                .collection("partner_profiles")
                .where("type", "==", query)
                .get()
                .then(snapshot => {
                  if (!snapshot.empty) {
                    this.items = [];
                    snapshot.forEach(doc => {
                      this.itemFound = doc.data();
                      this.itemFound.id = doc.id;
                      this.items.push(this.itemFound);
                    });
                  } else {
                    fb.db
                      .collection("partner_profiles")
                      .doc(query)
                      .get()
                      .then(doc => {
                        if (doc.data()) {
                          this.itemFound = doc.data();
                          this.itemFound.id = doc.id;
                          this.items = [this.itemFound];
                        } else {
                          this.noData = true;
                        }
                      })
                      .catch(() => {
                        this.noData = true;
                      });
                  }
                });
            }
          });
      } else {
        this.$bind(
          "items",
          fb.db.collection("partner_profiles").orderBy("name")
        );
      }
    }
  }
};
</script>
